import { render, staticRenderFns } from "./CallInfo.vue?vue&type=template&id=11f1f4d8&scoped=true"
import script from "./CallInfo.vue?vue&type=script&lang=js"
export * from "./CallInfo.vue?vue&type=script&lang=js"
import style0 from "./CallInfo.vue?vue&type=style&index=0&id=11f1f4d8&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11f1f4d8",
  null
  
)

export default component.exports